import Guest from './guest'

export default [Guest]
